"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Signup/Setup/Sections/Password/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _Form = require('web/components/Form');
var _PasswordInput = require('web/components/PasswordInput'); var _PasswordInput2 = _interopRequireDefault(_PasswordInput);
var _AuthFrame = require('web/components/AuthFrame');
var _components = require('web/screens/Signup/components');
var _app = require('shared/constants/app');
var _useFieldErrorDisplay = require('shared/hooks/useFieldErrorDisplay'); var _useFieldErrorDisplay2 = _interopRequireDefault(_useFieldErrorDisplay);









const passwordInputId = 'password'
const passwordConfirmationInputId = 'passwordConfirmation'

 const PASSWORD_RULES = 'Use 12 or more characters with mixed case and a symbol. Avoid "bloom" and dates.'; exports.PASSWORD_RULES = PASSWORD_RULES
 const PASSWORD_MISMATCH = "Passwords don't match."; exports.PASSWORD_MISMATCH = PASSWORD_MISMATCH

const PasswordSection = ({ password: presetPassword, onSubmit, onBack, error }) => {
  const [password, setPassword] = _react.useState.call(void 0, presetPassword || '')
  const [passwordConfirmation, setPasswordConfirmation] = _react.useState.call(void 0, presetPassword || '')
  const [isPasswordStrong, setIsPasswordStrong] = _react.useState.call(void 0, false)
  const isConfirmationCorrect = password === passwordConfirmation
  // The mismatch shows once they leave the confirmation after typing (never
  // while it is being typed), then clears as soon as the two match.
  const display = _useFieldErrorDisplay2.default.call(void 0, {
    [passwordConfirmationInputId]: !!passwordConfirmation && !isConfirmationCorrect ? exports.PASSWORD_MISMATCH : undefined,
  })
  const { onType, onLeave } = display
  const onConfirmationBlur = _react.useCallback.call(void 0, () => onLeave(passwordConfirmationInputId, passwordConfirmation), [onLeave, passwordConfirmation])
  const shouldShowMismatchWarning = !!display.shown(passwordConfirmationInputId)
  const canContinue = password && isPasswordStrong && isConfirmationCorrect

  const handleChange = _react.useCallback.call(void 0, 
    (id, val) => {
      onType(id)
      if (id === passwordInputId) setPassword(val)
      if (id === passwordConfirmationInputId) setPasswordConfirmation(val)
    },
    [onType],
  )

  const handleSubmit = _react.useCallback.call(void 0, 
    (e) => {
      e.preventDefault()
      onSubmit(password)
    },
    [onSubmit, password],
  )

  return (
    _react2.default.createElement('form', { onSubmit: handleSubmit, className: "signup-password", __self: this, __source: {fileName: _jsxFileName, lineNumber: 57}}
      , _react2.default.createElement(_components.SignupStepHeader, { title: "Create a password"  , subtitle: exports.PASSWORD_RULES, __self: this, __source: {fileName: _jsxFileName, lineNumber: 58}} )
      , _react2.default.createElement(_Form.InputSectionWrapper, { title: "New password" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 59}}
        , _react2.default.createElement(_PasswordInput2.default, {
          autoFocus: true,
          value: password,
          inputId: passwordInputId,
          onChange: handleChange,
          onValidated: setIsPasswordStrong,
          placeholder: "Enter a new password"   ,
          autoComplete: "new-password",
          maxLength: _app.MAX_PASSWORD_LENGTH,
          hasError: !!error, __self: this, __source: {fileName: _jsxFileName, lineNumber: 60}}
        )
      )

      , _react2.default.createElement('div', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 73}}
        , _react2.default.createElement(_Form.InputSectionWrapper, { title: "Confirm password" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 74}}
          , _react2.default.createElement(_PasswordInput2.default, {
            value: passwordConfirmation,
            inputId: passwordConfirmationInputId,
            onChange: handleChange,
            onBlur: onConfirmationBlur,
            placeholder: "Confirm password" ,
            autoComplete: "new-password",
            maxLength: _app.MAX_PASSWORD_LENGTH,
            hasError: shouldShowMismatchWarning, __self: this, __source: {fileName: _jsxFileName, lineNumber: 75}}
          )
        )
        , _react2.default.createElement(_AuthFrame.FieldError, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 86}},  shouldShowMismatchWarning ? exports.PASSWORD_MISMATCH : null )
      )
      ,  error && _react2.default.createElement(_AuthFrame.Callout, { message: error, __self: this, __source: {fileName: _jsxFileName, lineNumber: 88}} ) 
      , _react2.default.createElement(_components.SignupStepControls, { onBack: onBack, isNextDisabled: !canContinue, __self: this, __source: {fileName: _jsxFileName, lineNumber: 89}} )
    )
  )
}

exports. default = PasswordSection
